<template>
  <ValidationObserver ref="form" #default="{ dirty, valid }">
    <main class="content">
      <div class="content__heading content__heading--navigation">
        <h1>
          <i class="icon--tags"></i> {{ $t('labels.listTitle') }}
          <small v-if="labelList !== 'undefined'">({{ $store.getters['label/total'] }})</small>
        </h1>

        <nav class="navigation--buttonGroup">
          <button @click="showModal" class="navigation--buttonGroup__text">
            <i class="icon--plus"></i> {{ $t('labels.add') }}
          </button>
        </nav>
      </div>

      <section class="content--boxed">

        <input :placeholder="$t('search.labels')" type="text" name="search" v-model="search" :required="false"
               class="input input--search"/>

        <div class="table table--badged" v-if="labelList.length > 0">

          <div class="table--badged__row table--badged__row--clickable"
               :class="{'table--badged__row--clickable': label.count > 0}"
               v-for="label in labelList"
               :key="label.uuid" @click="goTo(label)">
            <div class="table--badged__badge table--badged__badge--light"><i class="icon--tags"></i></div>

            <div class="table--badged__description">
              <h3>
                {{ label.name }}
              </h3>
            </div>
            <div class="navigation--buttonGroup navigation--buttonGroup--table">
              <button @click.stop="prepEdit(label)"><i class="icon--edit"></i></button>
              <button @click.stop="$modal.show('confirmation', { id: label.uuid })"><i class="icon--delete"></i>
              </button>
            </div>

          </div>
        </div>
        <template v-if="total === 0">
          <div class="message" v-if="!isFilterApplied">
            {{ $t('messages.noLabels') }}
          </div>
          <div class="message" v-else>
            {{ $t('messages.noResults') }}
          </div>
        </template>
      </section>

      <DqPaginate v-if="lastPage > 1" v-model="page" :page-count="lastPage" :click-handler="dispatchList"/>
      <ModalLabel :edit="edit" @clearEdit="clearEdit" @hideModal="hideModal" @init="init"/>
      <Confirm @confirmed="remove"/>

    </main>

  </ValidationObserver>
</template>

<script>
import _debounce from 'lodash.debounce'
import ModalLabel from '@/components/Modal/Label'
import { errHandler } from '@/helpers'
import DqPaginate from '@/components/Parts/DqPaginate'
import Confirm from '@/components/Modal/Confirm'
import { mapGetters } from 'vuex'

export default {
  name: 'Label-Index',
  components: {
    Confirm,
    DqPaginate,
    ModalLabel
  },
  beforeMount () {
    this.$store.commit('loader/startIntLoading')
  },
  async mounted () {
    await this.$store.dispatch('label/resetFilters')
    this.init(true)
    this.debouncedSearch = _debounce(async () => {
      await this.$store.dispatch('label/resetPage', { resetPage: true })
      this.dispatchList()
    }, 200)
    if (this.$route.query.open) {
      this.showModal()
    }
  },
  data: () => {
    return {
      edit: false,
      form: {
        name: ''
      },
      submit: false,
      columns: [
        {
          key: 'name',
          label: 'general.name',
          sortable: true
        },
        {
          label: 'general.actions',
          key: 'actions',
          sortable: true,
          htmlContent: true
        }
      ]
    }
  },
  computed: {
    ...mapGetters('label', ['labelList', 'lastPage', 'total', 'isFilterApplied']),
    search: {
      get () {
        return this.$store.getters['label/search']
      },
      set (value) {
        this.$store.commit('label/setSearch', value)
      }
    },
    page: {
      get () {
        return this.$store.getters['label/currentPage']
      },
      set (value) {
        this.$store.commit('label/setPage', value)
      }
    }
  },
  methods: {
    goTo (label) {
      if (label.count > 0) {
        this.$router.push({ name: 'label.slug.index', params: { slug: label.slug } })
      }
    },
    clearEdit () {
      this.edit = false
    },
    prepEdit (item) {
      this.edit = item
      this.showModal()
    },
    async init (resetPage = false) {
      try {
        await this.$store.dispatch('label/resetPage', { resetPage })
        this.dispatchList()
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      }
    },
    async dispatchList () {
      try {
        await this.$store.dispatch('label/get')
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      } finally {
        this.$store.dispatch('loader/stopIntLoading')
      }
    },
    showModal () {
      this.$modal.show('add-label')
    },
    hideModal () {
      this.$modal.hide('add-label')
    },
    async remove ({ id }) {
      if (this.submit) { return false }
      try {
        this.submit = true
        await this.$store.dispatch('label/delete', id)
        this.init()
        this.$toasted.global.success_message({
          message: this.$t('labels.deleteSuccess')
        })
        this.$modal.hide('confirmation')
      } catch (e) {
        errHandler(e, this.$toasted, key => this.$t(key))
      } finally {
        this.submit = false
      }
    }
  },
  watch: {
    search () {
      this.debouncedSearch()
    }
  }
}
</script>
